<template>
  <div class="step-qna property-outdoor-questions-selector">
    <div>
      <div class="d-flex justify-content-center">
        <h4>Water Supply?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="waterSupply === 'Public - City'"
              @click="onSelectedValue('waterSupply', 'waterSupply', 'Public - City')"
            >
              Public - City
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="waterSupply === 'Well'"
              @click="onSelectedValue('waterSupply', 'waterSupply', 'Well')"
            >
              Well
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Sewer?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="sewer === 'Public - City'"
              @click="onSelectedValue('sewer', 'sewer', 'Public - City')"
            >
              Public - City
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="sewer === 'Septic Tank'"
              @click="onSelectedValue('sewer', 'sewer', 'Septic Tank')"
            >
              Septic Tank
            </b-button>          
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Solar Panels?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="solarPanels === 'Yes - Owned'"
              @click="onSelectedValue('solarPanels', 'solarPanels', 'Yes - Owned')"
            >
              Yes - Owned
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="solarPanels === 'Yes - Leased'"
              @click="onSelectedValue('solarPanels', 'solarPanels', 'Yes - Leased')"
            >
              Yes - Leased
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="solarPanels === 'No'"
              @click="onSelectedValue('solarPanels', 'solarPanels', 'No')"
            >
              No
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Is your home in a Flood Zone?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="floodZone === 'Yes'"
              @click="onSelectedValue('floodZone', 'homeInFloodZone', 'Yes')"
            >
              Yes
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="floodZone === 'No'"
              @click="onSelectedValue('floodZone', 'homeInFloodZone', 'No')"
            >
              No
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="floodZone === 'Unsure'"
              @click="onSelectedValue('floodZone', 'homeInFloodZone', 'Unsure')"
            >
              Unsure
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Home Condition?</h4>
      </div>
      <b-container class="h-buttons">      
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="homeCondition === 'Very good (needs no work inside or outside)'"
              @click="onSelectedValue('homeCondition', 'homeCondition', 'Very good (needs no work inside or outside)')"
            >
              Very good (needs no work inside or outside)
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="homeCondition === 'Fair (could use some things inside or outside)'"
              @click="onSelectedValue('homeCondition', 'homeCondition', 'Fair (could use some things inside or outside)')"
            >
              Fair (could use some things inside or outside)
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="homeCondition === 'Poor (needs work inside or outside)'"
              @click="onSelectedValue('homeCondition', 'homeCondition', 'Poor (needs work inside or outside)')"
            >
              Poor (needs work inside or outside)
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col class="text-right">
            <h5>Age of Roof:</h5>
          </b-col>
          <b-col class="text-left">
            <b-form-input id="roof-age" v-model="roofAge" class="number-input" type="number"
              @blur="onBlurValue('roofAge', 'ageOfRoof')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col class="text-right">
            <h5>Age of HVAC:</h5>
          </b-col>
          <b-col class="text-left">
            <b-form-input id="hvac-age" v-model="hvacAge" class="number-input" type="number"
              @blur="onBlurValue('hvacAge', 'ageOfHvac')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col class="text-right">
            <h5>Water Heater Age:</h5>
          </b-col>
          <b-col class="text-left">
            <b-form-input id="floor-count" v-model="waterHeaterAge" class="number-input" type="number"
              @blur="onBlurValue('waterHeaterAge', 'waterHeaterAge')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Water Heater Type?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="waterHeaterType === 'Tank'"
              @click="onSelectedValue('waterHeaterType', 'waterHeaterType', 'Tank')"
            >
              Tank
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="waterHeaterType === 'Tankless'"
              @click="onSelectedValue('waterHeaterType', 'waterHeaterType', 'Tankless')"
            >
              Tankless
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
import {saveField} from "@/services/apiService";

export default {
  name: "PropertyQuestions",
  data (){
    return {
      waterSupply: undefined,
      sewer: undefined,
      solarPanels: undefined,
      floodZone: undefined,
      homeCondition: undefined,
      roofAge: 0,
      hvacAge: 0,
      waterHeaterType: undefined,
      waterHeaterAge: 0
    }
  },
  methods: {    
    onSelectedValue(field, saveAs, value) {
      this.setLocalValue(field, value)
      this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
      saveField(saveAs, value);
    },
    onBlurValue(field, saveAs) {
      const val = this.getLocalValue(field);
      this.onSelectedValue(field, saveAs, val)
    },
    setLocalValue(field, value) {
      switch (field) {
        case 'waterSupply':
          this.waterSupply = value;
          break;
        case 'sewer':
          this.sewer = value;
          break;
        case 'solarPanels':
          this.solarPanels = value;
          break;
        case 'floodZone':
          this.floodZone = value;
          break;
        case 'homeCondition':
          this.homeCondition = value;
          break;
        case 'roofAge':
          this.roofAge = value;
          break;
        case 'hvacAge':
          this.hvacAge = value;
          break;
        case 'waterHeaterType':
          this.waterHeaterType = value;
          break;
        case 'waterHeaterAge':
          this.waterHeaterAge = value;
          break;        
        default:
          return false;
      }
    },
    getLocalValue(field) {
      switch (field) {
        case 'roofAge':
          return this.roofAge;
        case 'hvacAge':
          return this.hvacAge;
        case 'waterHeaterAge':
          return this.waterHeaterAge;      
        default:
          return false;
      }
    }
  }
}
</script>